import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { AlarmClockIcon, TrendingUpIcon } from 'lucide-react';
const TOTAL_SECONDS = 15 * 60;
export function UrgencyModule() {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    if (secondsLeft <= 0) return;
    const id = setInterval(() => {
      setSecondsLeft(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, [secondsLeft]);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const elapsedPct = (TOTAL_SECONDS - secondsLeft) / TOTAL_SECONDS * 100;
  // Cupos tomados: arranca en 60% y sube hasta 100% a medida que corre el tiempo
  const START_PCT = 60;
  const takenPct = START_PCT + elapsedPct * ((100 - START_PCT) / 100);
  const isExpired = secondsLeft === 0;
  return <div className="px-4 md:px-8 -mb-4 md:-mb-8 relative z-10" data-id="element-327">
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.4
    }} className="max-w-2xl mx-auto rounded-2xl shadow-2xl border-2 border-amber-400/50 overflow-hidden relative" style={{
      backgroundColor: '#DC2626',
      color: '#ffffff'
    }} data-id="element-328">
        <div className="absolute -top-12 -right-12 w-32 h-32 bg-amber-400/30 rounded-full blur-3xl pointer-events-none" data-id="element-329" />

        <div className="relative p-4 md:p-5" data-id="element-330">
          {/* Top row: label + countdown */}
          <div className="flex items-center justify-between gap-3 mb-3 md:mb-4" data-id="element-331">
            <div className="flex items-center gap-2" data-id="element-332">
              <span className="relative flex h-2.5 w-2.5" data-id="element-333">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-300 opacity-75" data-id="element-334" />
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-amber-300" data-id="element-335" />
              </span>
              <span className="text-[10px] md:text-xs font-black uppercase tracking-widest" data-id="element-336">
                Oferta por tiempo limitado
              </span>
            </div>

            <div className="flex items-center gap-1.5 bg-black/25 px-2.5 py-1 rounded-lg border border-white/10" data-id="element-337">
              <AlarmClockIcon size={14} className="text-amber-300" data-id="element-338" />
              <span className="font-mono font-black text-lg md:text-xl tabular-nums tracking-tight leading-none" data-id="element-339">
                {isExpired ? '00:00' : `${pad(minutes)}:${pad(seconds)}`}
              </span>
            </div>
          </div>

          {/* Warning */}
          <div className="flex items-start gap-2.5 mb-3 md:mb-4" data-id="element-340">
            <TrendingUpIcon className="shrink-0 text-amber-300 mt-0.5" size={18} data-id="element-341" />
            <p className="text-sm md:text-base font-bold leading-tight" data-id="element-342">
              Cuando se acaben los cupos el precio sube{' '}
              <span className="bg-amber-300 text-red-900 px-1.5 py-0.5 rounded font-black" data-id="element-343">
                +$8.000
              </span>{' '}
              y NO vuelve a bajar.
            </p>
          </div>

          {/* Progress bar */}
          <div className="relative" data-id="element-344">
            <div className="w-full bg-black/30 rounded-full h-2 overflow-hidden" data-id="element-345">
              <motion.div className="bg-amber-300 h-2 rounded-full" initial={false} animate={{
              width: `${takenPct}%`
            }} transition={{
              duration: 1,
              ease: 'linear'
            }} data-id="element-346" />
            </div>
            <div className="flex justify-between mt-1.5 text-[10px] md:text-[11px] font-bold text-white/85 uppercase tracking-wider" data-id="element-347">
              <span data-id="element-348">Cupos al precio actual</span>
              <span className="text-amber-300" data-id="element-349">
                {Math.round(takenPct)}% TOMADOS
              </span>
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}